import { render } from "./Portfolio-page.vue?vue&type=template&id=1eb98182"
import script from "./Portfolio-page.vue?vue&type=script&lang=js"
export * from "./Portfolio-page.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__